import { render, staticRenderFns } from "./GroupTabs.vue?vue&type=template&id=49520c96&scoped=true"
import script from "./GroupTabs.vue?vue&type=script&lang=js"
export * from "./GroupTabs.vue?vue&type=script&lang=js"
import style0 from "./GroupTabs.vue?vue&type=style&index=0&id=49520c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49520c96",
  null
  
)

export default component.exports